import { GetServerSideProps } from 'next';

export const getServerSideProps: GetServerSideProps = async (context) => ({
  redirect: {
    destination: `/admin/meetings/quick-call/${context.params?.['quick-call-id']}/new`,
    permanent: false,
  },
});

export default function AdminQuickCallNewByIdRedirect() {
  return null;
}
